import { BaseOutput, isBaseOutput } from './base-output.model'
import { has, isString, isObject, isFinite } from 'lodash'
import { SendingMode } from '@mycicero/ng-invoicing-data-form/lib/sending-mode.enum'

export interface GetInvoicingSendingModalitiesOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  InvoiceSendingModeList: InvoiceSendingModeList[]
}

export interface InvoiceSendingModeList {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Id: SendingMode
  // eslint-disable-next-line @typescript-eslint/naming-convention
  InvoiceSendingMode: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Default: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isInvoiceSendingModeList = (obj: any): obj is InvoiceSendingModeList => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Id = 'Id'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const InvoiceSendingMode = 'InvoiceSendingMode'

  return (
    isObject(obj) &&
    has(obj, Id) &&
    isFinite(obj[Id]) &&
    has(obj, InvoiceSendingMode) &&
    isString(obj[InvoiceSendingMode])
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGetInvoicingSendingModalitiesOutput = (obj: any): obj is GetInvoicingSendingModalitiesOutput => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const InvoiceSendingModeList = 'InvoiceSendingModeList'

  return (
    isBaseOutput(obj) &&
    has(obj, InvoiceSendingModeList) &&
    Array.isArray(obj[InvoiceSendingModeList]) &&
    (!obj[InvoiceSendingModeList].length || isInvoiceSendingModeList(obj[InvoiceSendingModeList][0]))
  )
}
